'use client';

import React, { useState } from 'react';
import { StyledDiv } from './affiliatesHero.styles';
import { IoIosArrowForward } from '@react-icons/all-files/io/IoIosArrowForward';
import { CustomLink } from '../link/link.comp';
import { Header } from '../header/header.comp';

const planPrice = {
    starter: 2.5,
    expert: 80,
    agency: 650,
};

const rangeTitles: any = {
    starter: `1 Widget ($${planPrice.starter}/mo)`,
    expert: `50 Widgets ($${planPrice.expert}/mo)`,
    agency: `1K Widgets ($${planPrice.agency}/mo)`,
};


export const AffiliatesHero = () => {
    const [referrals, setReferrals] = useState({
        starter: 100,
        expert: 50,
        agency: 10,
    });
    const referralsSum =
        (referrals.starter * planPrice.starter +
            referrals.expert * planPrice.expert +
            referrals.agency * planPrice.agency);

    const referralsSumString = (Math.round(referralsSum * 10) / 10).toLocaleString();

    return (
        <StyledDiv>
            <div className='hero-wrapper'>
                <Header />
                <div className="inner-wrapper">
                    <h1>Join Common Ninja’s Affiliate Program!</h1>
                    <h2>Get a Chance To Earn Up to 30% CPA</h2>
                    <CustomLink target={'_blank'} className='try-button' href={`https://www.commoninja.com/affiliates/join`} >
                        Apply Now
                        <IoIosArrowForward className='icon' />
                    </CustomLink>
                </div>
            </div>
            <section className="referrals-section">
                <h2>
                    You Can Earn
                    <span>${referralsSumString}</span>
                    Every Month
                </h2>
                <div className="referrals">
                    {Object.keys(referrals).map((key: string) => (
                        <div key={key} className="referral">
                            <p>{rangeTitles[key]}</p>
                            <div className="slider">
                                <div className="track"></div>
                                <div
                                    className="trail"
                                    style={{ width: `${(referrals as any)[key] / 2}%` }}
                                ></div>
                                <input
                                    type="range"
                                    value={(referrals as any)[key] || 0}
                                    min={0}
                                    max={200}
                                    className="affiliate-progress"
                                    onChange={e => {
                                        if (parseInt(e.target.value) < 0) return;
                                        setReferrals({ ...referrals, [key]: e.target.value });
                                    }}
                                />
                            </div>
                            <p>
                                {(referrals as any)[key]} referral
                                {Number((referrals as any)[key]) !== 1 ? 's' : ''}
                            </p>
                        </div>
                    ))}
                </div>
            </section>
        </StyledDiv>
    );
};

